/**
 * 路由相关常量 — 集中管理默认路由、前缀、白名单等
 *
 * 避免同一路由字符串散落在 router/index.ts、MainLayout.vue 等多处，
 * 修改时只需改此文件即可全局生效。
 */

/** 默认首页路由 — 商业化产品入口 = 智能体工作台（登录后默认落地页） */
export const DEFAULT_ROUTE = '/agents/workspace'

/** 登录回跳 query key */
export const AUTH_REDIRECT_QUERY_KEY = 'redirect'

/** 知识中心路由前缀 */
export const KNOWLEDGE_ROUTE_PREFIX = '/knowledge'
export const KNOWLEDGE_DEFAULT_ROUTE = '/knowledge/metrics'

/** Agent 管理路由前缀 */
export const AGENT_ROUTE_PREFIX = '/agent'
export const AGENT_DEFAULT_ROUTE = '/agent/agents'

/** 执行中心路由前缀（原任务中心） */
export const MISSION_ROUTE_PREFIX = '/mission'
export const MISSION_DEFAULT_ROUTE = '/mission/tracing'

/** 管控中心路由前缀 */
export const CONTROL_ROUTE_PREFIX = '/control'
export const CONTROL_DEFAULT_ROUTE = '/control/projects'

/** 四大产品域路由前缀列表 */
export const PRODUCT_ROUTE_PREFIXES = [
  KNOWLEDGE_ROUTE_PREFIX,
  AGENT_ROUTE_PREFIX,
  MISSION_ROUTE_PREFIX,
  CONTROL_ROUTE_PREFIX,
] as const

/** 检查路径是否精确匹配某个产品域前缀（段边界安全） */
export function isProductRoute(path: string): boolean {
  return PRODUCT_ROUTE_PREFIXES.some(
    prefix => path === prefix || path.startsWith(prefix + '/')
  )
}

/**
 * 检查路径是否在管控中心 (/control) 域内 — 整域 admin。
 *
 * 历史教训（2026-05-06）：早期路由守卫把"四大产品域整体仅管理员可访问"，
 * 导致普通成员（member）打开任何九宫格菜单都被重定向回工作台，
 * 看上去就是"九宫格菜单进不去"。实际只有 /control 域（项目管理 / 系统监控）
 * 是 admin 专属，知识/Agent/任务三域应该放开给普通用户。
 */
export function isControlRoute(path: string): boolean {
  return path === CONTROL_ROUTE_PREFIX || path.startsWith(CONTROL_ROUTE_PREFIX + '/')
}

/** 查找路径匹配的产品域前缀 */
export function matchProductPrefix(path: string): string | undefined {
  return PRODUCT_ROUTE_PREFIXES.find(
    prefix => path === prefix || path.startsWith(prefix + '/')
  )
}

/** 不显示顶部导航栏的路由前缀列表 */
export const HIDDEN_NAV_ROUTE_PREFIXES = ['/login', '/daily-report']

/** 无需认证即可访问的路由名称白名单 */
export const PUBLIC_ROUTE_NAMES: ReadonlySet<string> = new Set([
    'login',
    'PublicChat',
    'forbidden',
])
